import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { collection, query, where, getDocs } from 'firebase/firestore';
import { db } from '../../../config/firebase';
import { useAuth } from '../../../context/AuthContext';

function BlogList() {
  const [blogs, setBlogs] = useState([]);
  const [loading, setLoading] = useState(true);
  const { user } = useAuth();

  useEffect(() => {
    const fetchBlogs = async () => {
      try {
        const q = query(collection(db, 'blogs'), where('authorId', '==', user.uid));
        const querySnapshot = await getDocs(q);
        const blogList = querySnapshot.docs.map(doc => ({
          id: doc.id,
          ...doc.data()
        }));
        setBlogs(blogList);
      } catch (error) {
        console.error('Bloglar yüklenirken hata:', error);
      } finally {
        setLoading(false);
      }
    };

    fetchBlogs();
  }, [user.uid]);

  if (loading) {
    return (
      <div className="flex justify-center items-center h-64">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600"></div>
      </div>
    );
  }

  return (
    <div className="container mx-auto px-4 py-8">
      <div className="flex justify-between items-center mb-6">
        <h1 className="text-2xl font-bold">Blog Yazıları</h1>
        <Link
          to="/editor/blogs/new"
          className="bg-blue-600 text-white px-4 py-2 rounded-md hover:bg-blue-700 transition"
        >
          Yeni Blog Yazısı
        </Link>
      </div>

      {blogs.length === 0 ? (
        <div className="text-center py-12 bg-gray-50 rounded-lg">
          <p className="text-gray-600">Henüz blog yazısı bulunmuyor.</p>
        </div>
      ) : (
        <div className="grid gap-6">
          {blogs.map((blog) => (
            <div
              key={blog.id}
              className="bg-white p-6 rounded-lg shadow-md hover:shadow-lg transition"
            >
              <div className="flex justify-between items-start">
                <div>
                  <h2 className="text-xl font-semibold mb-2">{blog.title}</h2>
                  <p className="text-gray-600 mb-4">{blog.description}</p>
                  <div className="flex items-center space-x-4 text-sm text-gray-500">
                    <span>Durum: {blog.status === 'published' ? 'Yayında' : 'Taslak'}</span>
                    <span>•</span>
                    <span>
                      {new Date(blog.createdAt?.toDate()).toLocaleDateString('tr-TR')}
                    </span>
                  </div>
                </div>
                <Link
                  to={`/editor/blogs/edit/${blog.id}`}
                  className="bg-gray-100 text-gray-600 px-4 py-2 rounded-md hover:bg-gray-200 transition"
                >
                  Düzenle
                </Link>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}

export default BlogList; 